import type { ConcedeAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { StoneFlickingCoreState } from "../types/game-state";
import {
  isParticipantActive,
  isParticipantKnown,
} from "../utils/participant-helpers";

export function validateConcede(
  state: StoneFlickingCoreState,
  action: ConcedeAction,
): ValidationResult {
  if (state.phase !== "INPUT_PHASE") {
    return { valid: false, error: "Not in input phase" };
  }

  if (!isParticipantKnown(state.participants, action.participantId)) {
    return { valid: false, error: "Unknown participant" };
  }

  if (
    !isParticipantActive(
      state.participants,
      state.eliminatedParticipants,
      action.participantId,
    )
  ) {
    return { valid: false, error: "Participant is already eliminated" };
  }

  return { valid: true };
}
